<template>
    <div class="newplan">
        <div class="newplan__head">
            <h4>Hola {{ showUserName() }}</h4>
            <div class="newplan__head__back">
                <a @click="back">
                    <img :src="require('@/assets/images/app/chevron.svg')" alt="" />
                </a>
                <span>Comprar un nuevo plan</span>
            </div>
        </div>
        <div class="newplan__body">
            <div class="newplan__body__steps">
                <div class="newplan__body__steps__head">
                    <ul class="steps">
                        <li class="steps__step"  @click="navigateToStep(step)" v-for="(step, index) in steps" v-bind:key="step.key"
                            :class="{ current: step.active || step.completed }">
                            <span>{{ index + 1 }}</span>
                            <p>{{ step.label }}</p>
                        </li>
                    </ul>
                </div>
                <template v-if="!flags.paymentCompleted">
                    <template v-if="currentStep.key === 'goal'">
                        <div class="newplan__body__steps__body">
                            <div class="saves-card">
                                <span class="saves-card__title mt-3">¿Cuánto deseas ahorrar al mes?</span>
                                <div class="saves-card__slider">
                                    <!---<vue3-slider v-model="goal.amount" :height="10" :handleScale="2.5"
                                        :color="'#0855c4'" :track-color="'#c5c5c5'" :min="amountSlider.min"
                                        :max="amountSlider.max" :step="amountSlider.interval" :tooltip="true"
                                        :tooltipText="'S/%v'" :tooltipTextColor="'#0855c4'" @change="changeAmount" />-->
                                    <Slider v-model="this.v$.goal.amount.$model" :step="amountSlider.interval"
                                        :format="{ prefix: 'S/ ' }" :min="amountSlider.min" :max="amountSlider.max"
                                        :orientation="'horizontal'" @change="changeAmount"></Slider>
                                    <span class="min">S/ {{ amountSlider.min }}</span>
                                    <span class="max">S/ {{ amountSlider.max }}</span>
                                </div>
                                <div class="saves-card__savings" v-if="!flags.loadingPlans">
                                    <span class="saves-card__savings__title mb-4">¿Por cuántos años deseas ahorrar?</span>
                                    <div class="saves-card__savings__years">
                                        <div class="form-group" v-for="(option, index) in options"
                                            v-bind:key="option.id">
                                            <input :id="'year-' + index" :value="option.id" v-model="goal.option"
                                                @change="changeOption(option)" name="saving-years" type="radio" />
                                            <label :for="'year-' + index">{{ option.duration }} años</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="saves-card__savings__loader" v-if="flags.loadingPlans">
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                    <span>Cargando planes</span>
                                </div>
                                <div v-if="allOptions.length === 0 && !flags.loadingPlans">
                                    <h4 class="text-center">
                                        No hemos encontrado un plan para ti
                                    </h4>
                                </div>
                                <div class="saves-card__annual visible-mobile">
                                    <div class="row">
                                        <div class="col">
                                            <div class="box">
                                                <p>S/ {{ formatNumber(selectedOption.saved) }}</p>
                                                <span>Mi aporte total</span>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="box">
                                                <p>S/ {{ formatNumber(selectedOption.saved) }}</p>
                                                <span>Mi ganancia</span>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="box">
                                                <p>S/ {{ formatNumber(selectedOption.saved) }}</p>
                                                <span>Devolución total</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="box-b">
                                        <div class="row">
                                            <div class="col">
                                                <span>Mi tasa de interés anual:</span>
                                            </div>
                                            <div class="col-4">
                                                <p>{{ selectedOption.tea }}%</p>
                                                <span>(TEA Referencial)</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="visible-mobile">
                                    <div class="d-flex justify-content-center">
                                        <button class="saves-card__annual__btn" @click="setOption(selectedOption)">
                                            Continuar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="step-space hidden-mobile"></div>
                            <div class="summary-card hidden-mobile" v-if="selectedOption">
                                <span class="summary-card__title">Mi plan</span>
                                <ul class="summary-card__data">
                                    <li>
                                        <div class="row">
                                            <div class="col-sm">
                                                <span>Mi aporte total</span>
                                            </div>
                                            <div class="col-sm">
                                                <p>S/ {{ formatNumber(selectedOption.saved) }}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="row">
                                            <div class="col-sm">
                                                <span>Mi ganancia</span>
                                            </div>
                                            <div class="col-sm">
                                                <p>S/ {{ formatNumber(selectedOption.won) }}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="row">
                                            <div class="col-sm">
                                                <span>Devolución total</span>
                                            </div>
                                            <div class="col-sm">
                                                <p>S/ {{ formatNumber(selectedOption.amount) }}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div class="summary-card__interest">
                                    <div class="row">
                                        <div class="col-sm">
                                            <span>Mi tasa de<br /> interés anual es:</span>
                                        </div>
                                        <div class="col-sm">
                                            <p>{{ selectedOption.tea }}%</p>
                                        </div>
                                        <div class="col-sm">
                                            <span>Aprovecha esta SUPER tasa <br> ahorrando DE A POCOS cada mes</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <button class="summary-card__btn" @click="setOption(selectedOption)">
                                        Continuar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <div class="quote">
                <div class="quote__step mt-3 mb-4" v-if="currentStep.key === 'payment'">
                    <div class="payment-step">
                        <div class="row justify-content-center">
                            <div class="col-md-12 col-sm-12 col-12 px-0">
                                <form action="">
                                    <div class="row">
                                        <div class="visible-mobile col-md-6 col-12">
                                            <div class="summary shadow-sm">
                                                <div class="summary__section">
                                                    <div class="
                              summary__section__label
                              text-main
                              mb-2
                              text-left
                            ">
                                                        Tu resumen de pago
                                                        <button type="button" @click="awesome = !awesome">
                                                            <p v-if="awesome">
                                                                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                            </p>
                                                            <p v-if="!awesome">
                                                                <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                            </p>
                                                        </button>
                                                    </div>
                                                    <div v-if="awesome">
                                                        <div class="summary__section__detail">
                                                            <span>Pago mensual:</span>
                                                            <b>S/ {{ formatNumber(goal.amount) }}</b>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <span>Per&iacute;odo:</span>
                                                            <b>{{ selectedOption.duration }} a&ntilde;os</b>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span class="d-block">Pago mensual:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <b class="d-block">S/ {{ formatNumber(goal.amount)
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Per&iacute;odo:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <b>{{ selectedOption.duration }} a&ntilde;os</b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Tu 2da fecha de pago:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span>{{ nextPaymentDate }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Ganancia:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span>S/ {{ formatNumber(selectedOption.won)
                                                                    }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Monto de cobertura:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span>S/ {{ formatNumber(goal.coverage) }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <!-- <small class="d-block w-100">
                                                                                                            Tus beneficiarios serán tu herederos
                                                                                                            legales. <br />
                                                                                                            Puedes hacer modificaciones luego de la
                                                                                                            compra en <br />
                                                                                                            nuestra plataforma digital.
                                                                                                        </small> -->
                                                        </div>
                                                        <div class="summary__section__infouser mb-2">
                                                            <span>Datos del Titular</span>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 text-upper text-uppercase ps-0">
                                                                    <span>{{ userInfo.identificationType }}:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span>{{ userInfo.identificationNumber }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Nombre:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span>{{ userInfo.firstName }}</span>
                                                                    <span>{{ userInfo.lastName }} {{
                                                                            userInfo.secondLastName
                                                                    }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Fecha de Nacimiento:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span>{{ userInfo.inputDob }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Celular:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span>{{ userInfo.phone }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="summary__section__detail">
                                                            <div class="row w-100">
                                                                <div class="col-7 ps-0">
                                                                    <span>Correo:</span>
                                                                </div>
                                                                <div class="col-5 pe-0">
                                                                    <span><a >{{
                                                                            userInfo.email
                                                                    }}</a></span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="summary__info">
                                                            <div class="summary__section__detail">
                                                                <span class="text-center">
                                                                    Enviaremos el contrato a tu correo con esta
                                                                    información detallada.
                                                                </span>
                                                            </div>
                                                            <div class="summary__section__detail">
                                                                <span class="text-center">Puedes modificar los
                                                                    beneficiarios de tu
                                                                    seguro de vida enviando un correo a <br>
                                                                    <a
                                                                        href="mailto:rumbo@interseguro.com.pe">rumbo@interseguro.com.pe</a></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!--CARD 1 ESCRITORIO-->
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="paycard card card-form card-1-quote-step-2">
                                <div class="paycard__box card-body">
                                    <div class="visible-mobile text-center mt-2">
                                        <span>Aceptamos todas las tarjetas:</span>
                                        <div class="payments-cards text-center">
                                            <div class="card-brands">
                                                <img :src="require('@/assets/images/app/card-brands.png')" alt=""
                                                    class="input-icon-left w-100" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="hidden-mobile">
                                        <div class="payments-cards text-center mt-2">
                                            <span>Aceptamos todas las tarjetas:</span>
                                            <div class="card-brands">
                                                <img :src="require('@/assets/images/app/card-brands.png')" alt=""
                                                    class="input-icon-left" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="cardpays px-2">
                                        <form action="">
                                            <div class="form-group card-form mb-0">
                                                <div class="row">
                                                    <div class="col-md-12 col-sm-12 col-12" :class="{
                                                        invalid: this.v$.payment.creditCardNumber.$error,
                                                    }">
                                                        <div class="form-group">
                                                            <img :src="
                                                                require('@/assets/images/app/Trazado14308.svg')
                                                            " v-if="payment.creditCardType === ''" alt=""
                                                                class="input-icon-left" />
                                                            <img :src="require('@/assets/images/app/visa.svg')"
                                                                v-if="payment.creditCardType === 'VISA'" alt=""
                                                                class="input-card" />
                                                            <img :src="require('@/assets/images/app/mc.svg')"
                                                                v-if="payment.creditCardType === 'MASTERCARD'" alt=""
                                                                class="input-card" />
                                                            <img :src="require('@/assets/images/app/diners.svg')"
                                                                v-if="payment.creditCardType === 'DINERS'" alt=""
                                                                class="input-card" />
                                                            <img :src="require('@/assets/images/app/amex.svg')"
                                                                v-if="payment.creditCardType === 'AMEX'" alt=""
                                                                class="input-card" />
                                                            <input type="text" class="form-control cc-input"
                                                                placeholder="Número de tarjeta"
                                                                data-culqi="card[number]" id="card[number]"
                                                                v-mask="'#### #### #### ####'" v-model="
                                                                    this.v$.payment.creditCardNumber.$model
                                                                " @keyup="validateCreditCard()"
                                                                @change="savePaymentEvent()" />
                                                            <small>Por favor ingresa el n&uacute;mero de tu
                                                                tarjeta</small>
                                                            <img v-if="payment.validCard" :src="
                                                                require('@/assets/images/app/check-color.svg')
                                                            " class="valid-card-icon" alt="" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-sm-6 col-6" :class="{
                                                        invalid:
                                                            this.v$.payment.expirationDate.$error ||
                                                            this.flags.invalidExpirationDate,
                                                    }">
                                                        <div class="form-group">
                                                            <img :src="require('@/assets/images/app/img1.svg')" alt=""
                                                                class="input-icon-left" />
                                                            <input type="text" class="form-control" placeholder="MM/AA"
                                                                maxlength="5"
                                                                v-model="this.v$.payment.expirationDate.$model"
                                                                v-mask="'##/##'" @change="setExpirationDate()"
                                                                @keydown="validateInput($event, /^\d+$/)" />
                                                            <small>Por favor ingresa una fecha de
                                                                expiraci&oacute;n v&aacute;lida</small>
                                                            <input type="hidden" size="2"
                                                                v-model="this.v$.payment.month.$model"
                                                                data-culqi="card[exp_month]" id="card[exp_month]" />
                                                            <input type="hidden" size="4"
                                                                v-model="this.v$.payment.year.$model"
                                                                data-culqi="card[exp_year]" id="card[exp_year]" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-sm-6 col-6" :class="{
                                                        invalid: this.v$.payment.maskedCvv.$error,
                                                    }">
                                                        <div class="form-group">
                                                            <img :src="require('@/assets/images/app/lock.svg')" alt=""
                                                                class="input-icon-left" />
                                                            <input type="text" class="form-control" placeholder="CVV"
                                                                maxlength="4" v-model="this.v$.payment.maskedCvv.$model"
                                                                @change="
    maskCvv();
savePaymentEvent();
                                                                " @keydown="validateInput($event, /^\d+$/)" />
                                                            <small>Por favor ingresa el c&oacute;digo CVV</small>
                                                            <input type="hidden" size="4"
                                                                v-model="this.v$.payment.cvv.$model"
                                                                data-culqi="card[cvv]" id="card[cvv]" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 col-md-6 col-sm-6">
                                                    <div class="form-paymenth form-group" :class="{
                                                        invalid: this.v$.payment.placeholder.$error,
                                                    }">
                                                        <input style="padding-left: 15px" type="text"
                                                            class="form-control" placeholder="Nombre" @keydown="
                                                                validateInput(
                                                                    $event,
                                                                    /^[ñA-Za-z _\s]*[ñA-Za-z\s][ñA-Za-z _\s]*$/
                                                                )
                                                            " v-model="this.v$.payment.placeholder.$model" />
                                                        <small>Por favor ingresa el titular de la tarjeta</small>
                                                        <input type="hidden" class="form-control"
                                                            v-model="this.v$.payment.email.$model"
                                                            data-culqi="card[email]" id="card[email]" />
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-sm-6">
                                                    <div class="form-group"
                                                        :class="{ invalid: this.v$.payment.email.$error }">
                                                        <input style="padding-left: 15px" type="text"
                                                            placeholder="Correo electrónico" class="form-control"
                                                            v-model="this.v$.payment.email.$model"
                                                            data-culqi="card[email]" id="card[email]" />
                                                        <small>Por favor ingresa tu correo electrónico</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="customCheckDisabled2" v-model="automaticDebit" />
                                                    <label class="custom-control-label" for="customCheckDisabled2">
                                                        Deseo afiliarme al débito automático
                                                        <br />
                                                        <span class="text-main d-block" v-if="!automaticDebit">¿Estás
                                                            seguro? ¡Los clientes que usan
                                                            afiliación
                                                            automática llegan a sus objetivos de ahorro 3
                                                            veces más rápido!</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </form>
                                        <div class="payment-footer pl-0 pr-0">
                                            <div class="visible-mobile">
                                                <div class="d-flex justify-content-center">
                                                    <button type="button" class="paycard__box__btn"
                                                        @click="placeOrder()" :disabled="flags.paying">
                                                        <span v-if="!flags.paying">Pagar</span>
                                                        <i class="fas fa-circle-notch fa-spin" v-if="flags.paying"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--CARD RESUMEN PAGO DESKTOP-->
                        <div class="hidden-mobile col-md-5 col-12 pl-3 ps-5">
                            <div class="summary card-2-quote-step-2">
                                <div class="summary__section">
                                    <div class="summary__section__label text-main mb-2">
                                        Tu resumen de pago
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Pago mensual:</span>
                                            </div>
                                            <div class="col pl-0">
                                                <b>S/ {{ formatNumber(goal.amount) }}</b>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Per&iacute;odo:</span>
                                            </div>
                                            <div class="col pl-0">
                                                <b>{{ selectedOption.duration }} a&ntilde;os</b>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Tu 2da fecha de pago:</span>
                                            </div>
                                            <div class="col pl-0">
                                                {{ nextPaymentDate }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Ganancia:</span>
                                            </div>
                                            <div class="col pl-0">
                                                S/ {{ formatNumber(selectedOption.won) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Monto de cobertura:</span>
                                            </div>
                                            <div class="col pl-0">
                                                S/ {{ formatNumber(goal.coverage) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__infouser">
                                        <span>Datos del Titular</span>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Nombre:</span>
                                            </div>
                                            <div class="col pl-0">
                                                <span>
                                                    {{ userInfo.firstName }}
                                                </span>
                                                <span class="d-block">
                                                    {{ userInfo.lastName }}
                                                    {{ userInfo.secondLastName }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span class="text-upper text-uppercase">{{ userInfo.identificationType
                                                }}:</span>
                                            </div>
                                            <div class="col pl-0">
                                                {{ userInfo.identificationNumber }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Fecha de Nacimiento:</span>
                                            </div>
                                            <div class="col pl-0">
                                                {{ userInfo.inputDob }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Celular:</span>
                                            </div>
                                            <div class="col pl-0">
                                                {{ this.userInfo.phone }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__section__detail">
                                        <div class="row">
                                            <div class="col-7 pr-0">
                                                <span>Correo:</span>
                                            </div>
                                            <div class="col-5 pl-0">
                                                <span><a>{{ userInfo.email
                                                }}</a></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="summary__info">
                                        <div class="summary__section__detail">
                                            <div class="footer-text">
                                                <span>Puedes modificar los beneficiarios de tu seguro <br> de
                                                    vida enviando un correo a <a href="mailto:rumbo@interseguro.com.pe">rumbo@interseguro.com.pe</a></span>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <button type="button" class="summary__section__btn" @click="placeOrder()"
                                                :disabled="flags.paying">
                                                <span v-if="!flags.paying">Pagar</span>
                                                <i class="fas fa-circle-notch fa-spin" v-if="flags.paying"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="modal-success" ok-only ok-title="Entiendo" centered modal-class="modal-success"
            ref="modal-success">
            <div class="modal-success__header">
                <div class="modal-success__header__message">
                    <span>Exito</span>
                </div>
                <div class="modal-success__img">
                    <img :src="require('@/assets/images/app/checks.svg')" alt="" />
                </div>
            </div>

            <div class="modal-success__head">
                <div class="modal-success__head__content">
                    <span class="evaluate">Tu nuevo fondo ha sido creado correctamente.</span>
                    <span class="time">Recibir&aacute;s tu poliza en tu correo electr&oacute;nico
                        registrado..</span>
                </div>
                <div class="modal-success__head__btn">
                    <button type="button" class="accept" @click="closeModal('modal-success')">
                        Entendido
                    </button>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal-error" ok-only ok-title="Entiendo" centered modal-class="modal-error" ref="modal-error">
            <div class="modal-error__header">
                <div class="modal-error__header__message">
                    <span>Error</span>
                </div>
                <div class="modal-error__img">
                    <img :src="require('@/assets/images/app/error.svg')" alt="" />
                </div>
            </div>
            <div class="modal-error__head">
                <span v-if="errors.payment === ''">
                    Se ha presentado un error en nuestro sistema. Intenta nuevamente o
                    escríbenos a correo rumbo@interseguro.com.pe
                </span>
                <span v-if="errors.payment !== ''">
                    {{ errors.payment }}
                </span>
                <div class="modal-error__head__btn">
                    <button type="button" class="accept" @click="closeModal('modal-error')">
                        Entendido
                    </button>
                </div>
            </div>
        </b-modal>

        <!-- Tarjeta invalida -->
        <b-modal id="modal-error" ok-only ok-title="Entiendo" centered modal-class="modal-error" ref="modal-card-error">
            <div class="modal-error__header">
                <div class="modal-error__header__message">
                    <span>Error</span>
                </div>
                <div class="modal-error__img">
                    <img :src="require('@/assets/images/app/error.svg')" alt="" />
                </div>
            </div>
            <div class="modal-error__head">
                <span>Por favor ingrese una tarjeta de cr&eacute;dito o d&eacute;bito
                    v&aacute;lida</span>
                <div class="modal-error__head__btn">
                    <button type="button" class="accept" @click="closeModal('modal-card-error')">
                        Entendido
                    </button>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal-quote" ok-only ok-title="Entendido" centered size="sm" modal-class="modal-login"
            title="Enviar cotización" ref="modal-quote">
            <form class="modal-login__form">
                <div class="form-group" :class="{
                    invalid: this.v$.quote.email.$error,
                }">
                    <input type="text" class="form-control" placeholder="Ingrese su Email"
                        v-model="this.v$.quote.email.$model" />
                    <small>Ingrese un email v&aacute;lido</small>
                </div>
                <div class="form-group">
                    <button class="btn btn-pink" @click="sendQuote()" type="button" :disabled="flags.sendingQuote">
                        <span v-if="!flags.sendingQuote">Enviar cotización</span>
                        <i class="fas fa-circle-notch fa-spin" v-if="flags.sendingQuote"></i>
                    </button>
                </div>
                <p v-if="this.flags.sendedQuote" class="mt-2 text-success">
                    Cotizaci&oacute;n enviada, por favor revisa tu correo.
                </p>
            </form>
        </b-modal>

        <b-modal id="modal-login" ok-only ok-title="Entendido" centered size="sm" modal-class="modal-login"
            title="Inicia sesión">
            <form class="modal-login__form" v-if="!flags.validateOtp">
                <div class="form-group">
                    <div class="btncustom custom-control custom-radio custom-control-inline">
                        <input type="radio" id="loginDni" name="customRadioInline1" class="custom-control-input"
                            value="dni" v-model="this.v$.login.identificationType.$model" />
                        <label class="custom-control-label" for="loginDni">DNI</label>
                    </div>
                    <div class="btncustom custom-control custom-radio custom-control-inline">
                        <input type="radio" id="loginCe" name="customRadioInline1" class="custom-control-input"
                            value="ce" v-model="this.v$.login.identificationType.$model" />
                        <label class="custom-control-label" for="loginCe">CE</label>
                    </div>
                </div>
                <div class="form-group" :class="{
                    invalid: this.v$.login.identificationNumber.$error,
                }">
                    <label class="text-uppercase">{{ login.identificationType }}</label>
                    <input type="text" class="form-control" v-model="this.v$.login.identificationNumber.$model" />
                    <small>Ingrese un n&uacute;mero de documento v&aacute;lido</small>
                </div>
                <div class="form-group">
                    <button class="btn btn-second" @click="sendOtp()" type="button" :disabled="flags.logingIn">
                        <span v-if="!flags.logingIn">Ingresar</span>
                        <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
                    </button>
                </div>
            </form>
            <form class="modal-login__form" v-if="flags.validateOtp">
                <div class="form-group">
                    <label for="" style="color: #fff; position: initial">Ingresa el c&oacute;digo enviado al correo {{
                            otp.email
                    }}</label>
                </div>
                <div class="form-group" :class="{
                    invalid: this.v$.login.identificationNumber.$error,
                }">
                    <label class="text-uppercase">Codigo de autenticaci&oacute;n</label>
                    <input type="text" class="form-control" v-model="this.v$.otpCode.code.$model" />
                    <small>Ingrese un c&oacute;digo v&aacute;lido</small>
                </div>
                <div class="form-group">
                    <button class="btn btn-second" @click="validateOtp()" type="button" :disabled="flags.logingIn">
                        <span v-if="!flags.logingIn">Validar</span>
                        <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
                    </button>
                </div>
            </form>
        </b-modal>

        <!-- <b-modal
      id="modal-error"
      ok-only
      ok-title="Entiendo"
      centered
      size="sm"
      modal-class="modal-error"
      ref="modal-error"
    >
      <div class="modal-error__head">
        <img :src="require('@/assets/images/app/alert.svg')" alt="" />
        <h3>Parece que ha ocurrido un error</h3>
      </div>
      <div class="modal-error__head">
        <p>
          {{ errors.payment }}
        </p>
      </div>
    </b-modal> -->

        <b-modal id="modal-free-month" ok-only ok-title="Entiendo" centered size="lg" modal-class="modal-free-month"
            ref="modal-free-month">
            <div class="modal-free-month__head">
                ¡Tenemos un
                <img :src="require('@/assets/images/app/gift.svg')" alt="" /> para ti!
            </div>
            <div class="modal-free-month__countdown">
                <div class="time-box">
                    <div class="time-box__time">{{ hours }}</div>
                    <div class="time-box__label">Horas</div>
                </div>
                <div class="time-box">
                    <div class="time-box__time">{{ minutes }}</div>
                    <div class="time-box__label">Minutos</div>
                </div>
                <div class="time-box">
                    <div class="time-box__time">
                        {{ seconds < 10 ? "0" + seconds : seconds }} </div>
                            <div class="time-box__label">Segundos</div>
                    </div>
                </div>
                <div class="modal-free-month__content">
                    <div class="top-title">Te regalamos tu</div>
                    <div class="title">
                        <h4>Primer</h4>
                        <h2>Mes gratis</h2>
                        <p>Ahorra desde S/5 al día y protege a tu familia</p>
                    </div>
                    <div class="bullets">
                        <h4>¿Cómo funciona la cuota gratis?</h4>
                        <ul>
                            <li class="bullets__stepone">
                                <span>1</span>
                                <p>
                                    Haz crecer tu dinero
                                    <br />
                                    gratis desde hoy
                                </p>
                            </li>
                            <li class="bullets__steptwo">
                                <span>2</span>
                                <p>
                                    Tu familia estará
                                    <br />
                                    protegida al instante
                                </p>
                            </li>
                            <li class="bullets__stepthree">
                                <span>3</span>
                                <p>
                                    Realiza tu pago
                                    <br />
                                    y comunícate a nuestro
                                    <img :src="require('@/assets/images/app/wapp-chat.svg')" alt="" />
                                    <br />
                                    para la devolución
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="info">
                        Aplica 1 cuota gratis por cliente para aportes hasta S/400.
                    </div>
                    <div class="action">
                        <button class="btn btn-pink" @click="closeFreeMonthModal">
                            Continuar
                        </button>
                    </div>
                </div>
        </b-modal>

        <b-modal id="modal-error" ok-only ok-title="Entiendo" centered modal-class="modal-error" ref="modal-no-plans">
            <div class="modal-error__header">
                <div class="modal-error__header__message">
                    <span>Error</span>
                </div>
                <div class="modal-error__img">
                    <img :src="require('@/assets/images/app/error.svg')" alt="" />
                </div>
            </div>
            <div class="modal-error__head">
                <span>No hemos encontrado un plan para las condiciones escogidas.
                    <br />
                    Cambia el monto a pagar o la frecuencia de pago
                </span>
                <div class="modal-error__head__btn">
                    <button type="button" class="accept" @click="closeModal('modal-no-plans')">
                        Entendido
                    </button>
                </div>
            </div>
        </b-modal>

        <!-- <b-modal id="modal-no-plans" ok-only ok-title="Entiendo" centered size="sm" modal-class="modal-error"
            ref="modal-no-plans">
            <div class="modal-error__head">
                <h3>
                    
                </h3>
            </div>
            <div class="modal-error__head">
                <p>
                    
                </p>
            </div>
        </b-modal> -->

        <b-modal id="modal-loading" centered hide-backdrop size="sm" modal-class="modal-loading" ref="modal-loading">
            <img :src="require('@/assets/images/app/clock.gif')" alt="" />
            <h3>Tu pago se est&aacute; procesando</h3>
            <h4>Espera unos minutos por favor</h4>
        </b-modal>

        <b-modal id="modal-conditions" ok-only ok-title="Entendido" centered size="lg" modal-class="modal-conditions"
            title=" ">
            <b-card-text>
                <div class="general-conditions">
                    <h3>Condiciones generales</h3>
                    <p>
                        Para acceder a las condiciones generales y particulares de la
                        póliza, haz clic en los siguientes enlaces:
                        <a target="_blank"
                            href="https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_General.pdf">Condicionado
                            General</a>
                        <a target="_blank"
                            href="https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_Particular.pdf">Condicionado
                            Particular</a>
                    </p>
                    <h3>Exclusiones</h3>
                    <div class="row">
                        <div class="col-6">
                            <p>La cobertura escogida incluye:</p>
                            <ul>
                                <li>Fallecimiento por muerte natural.</li>
                            </ul>
                        </div>
                        <div class="col-6">
                            <p>La cobertura escogida NO incluye:</p>
                            <ul>
                                <li>Fallecimiento por muerte accidental.</li>
                                <li>Enfermedades graves.</li>
                                <li>Invalidez total y permanente.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </b-card-text>
        </b-modal>

        <b-modal id="modal-terms" ok-only ok-title="Entendido" centered size="lg"
            title="Declaración jurada del contratante">
            <b-card-text>
                <p>
                    Declaro que tengo conocimiento y acepto las Condiciones Generales,
                    Particulares, Especiales y Cláusulas Adicionales relacionadas con la
                    Póliza de Seguros de Interseguro Compañía de Seguros.
                </p>
                <p>
                    Certifico que las respuestas y declaraciones realizadas en este sitio
                    web son verídicas y que se ajustan a la realidad y de no serlo,
                    cualquier declaración falsa hecha por el Contratante, voluntaria o
                    involuntariamente, invalida esta solicitud y libera de toda
                    responsabilidad y compromiso indemnizatorio a Interseguro Compañía de
                    Seguros, quedando el seguro emitido en virtud de esta solicitud nulo y
                    sin efecto.
                </p>
                <p>
                    El Contratante otorga su consentimiento para que su Póliza de seguro
                    electrónica, endosos futuros, cartas y/u otra documentación, sean
                    enviados vía correo electrónico desde el dominio @interseguro. Todas
                    aquellos documentos y comunicaciones se entenderán por recibidos en la
                    casilla de correo electrónica declarada por el Contratante, a través
                    de la confirmación del servidor de destino. La póliza contendrá una
                    firma digital y una contraseña de acceso para visualizar el documento,
                    ello garantizará la autenticidad e integridad del documento, de
                    acuerdo con lo estipulado en la Ley N° 27269 - Ley de Firmas y
                    Certificados Digitales. Asimismo, declara conocer las medidas de
                    seguridad que debe adoptar para la recepción de los citados
                    documentos, las ventajas y riesgos asociados a esta modalidad de
                    envío, garantiza haber suministrado un correo electrónico válido en la
                    Solicitud de Seguro, el cual mantendrá activo y con espacio suficiente
                    para recibir la Póliza y se comprometen a informar su nuevo correo
                    electrónico, en caso sea dado de baja o desee modificar la cuenta de
                    correo declarada.
                </p>
            </b-card-text>
        </b-modal>

        <b-modal id="modal-policies" ok-only ok-title="Cerrar" centered size="lg" title="POLÍTICA DE PRIVACIDAD">
            <b-card-text>
                <p>
                    Sus datos personales serán utilizados por Interseguro Compañía de
                    Seguros S.A. (<b>INTERSEGURO</b>) para las siguientes finalidades:
                </p>
                <ul>
                    <li>Para la adquisición de productos de <b>INTERSEGURO</b></li>
                    <li>
                        Enviar documentos de contratación de productos de <b>INTERSEGURO</b>
                    </li>
                    <li>
                        Realizar cotizaciones de productos de <b>INTERSEGURO</b> por
                        solicitud del USUARIO
                    </li>
                </ul>
                <p>
                    Para mayor información puedes consultar la &nbsp;
                    <a href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro.pdf"
                        target="_blank" class="text-main" style="text-decoration: underline">Pol&iacute;tica de
                        privacidad</a>
                </p>
            </b-card-text>
        </b-modal>
    </div>
</template>
<script lang="ts">
import { BButton, BModal, VBModal, BCardText } from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import es from "vuejs-datepicker/dist/locale/translations/es";
// import VueSimpleRangeSlider from "vue-simple-range-slider";
// import "vue-simple-range-slider/dist/vueSimpleRangeSlider.css";
import VueSlider from "vue-3-slider-component";
import "vue-slider-component/theme/antd.css";
import {
    required,
    minLength,
    maxLength,
    email,
    numeric,
    sameAs,
    requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import ISHash from "../../../../@core/is-hash/is-hash";
import moment from "moment";
import "moment/locale/es";
import { mask, field, VueTheMask } from "vue-the-mask";
import { environment } from "../../../../environment/environment";
import slider from "vue3-slider";

declare const Culqi: any;

import { defineComponent } from "vue";
import { validate } from "@babel/types";
import useVuelidate from "@vuelidate/core";

//
import Slider from '@vueform/slider'
import analyticsService from "@/services/analytics-service";

export default defineComponent({
    components: {
        Datepicker,
        // VueSimpleRangeSlider,
        BCardText,
        BModal,
        VueSlider,
        field,
        VueTheMask,
        Slider,
        "vue3-slider": slider,
    },
    directives: { mask },
    data() {
        return {
            basePath: window["basePath"],
            apiUrl: environment.api,
            v$: useVuelidate(),
            steps: [
                {
                    key: "goal",
                    completed: false,
                    active: true,
                    label: "Cotiza",
                    title: "Programa tus ahorros",
                    description: "Ahora, elige cuánto ahorrar y por cuánto tiempo",
                },
                {
                    key: "payment",
                    completed: false,
                    active: false,
                    label: "Paga",
                    title: "Finaliza tu compra",
                    description: "¡Estás a solo un paso de construir tu meta!",
                },
            ],
            userInfo: {
                email: "",
                firstName: "",
                lastName: "",
                secondLastName: "",
                dateOfBirth: "",
                inputDob: "",
                gender: "",
                phone: "",
                identificationNumber: "",
                identificationType: "dni",
            },
            basicInfo: {
                dateOfBirth: "",
                gender: "",
            },
            login: {
                identificationNumber: "",
                identificationType: "dni",
            },
            otpCode: {
                code: "",
            },
            goal: {
                age: 0,
                amount: 300,
                coverage: 25000,
                period: 1,
                option: null,
            },
            payment: {
                firstName: "",
                lastName: "",
                secondLastName: "",
                creditCardNumber: "",
                creditCardType: "",
                validCard: false,
                placeholder: "",
                expirationDate: "",
                year: "",
                month: "",
                maskedCvv: "",
                cvv: "",
                invoice: false,
                email: "",
                phone: "",
            },
            quote: {
                email: "",
            },
            options: [],
            allOptions: [],
            periods: {
                1: {
                    id: 1,
                    name: "Mensual",
                },
                3: {
                    id: 3,
                    name: "Trimestral",
                },
                12: {
                    id: 12,
                    name: "Anual",
                },
            },
            coverages: {
                1: {
                    id: 25000,
                    name: "S/ 25,000",
                },
                2: {
                    id: 50000,
                    name: "S/ 50,000",
                },
                3: {
                    id: 75000,
                    name: "S/ 75,000",
                },
            },
            currentStep: {
                key: "goal",
                completed: false,
                active: true,
                label: "Cotiza",
                title: "Programa tus ahorros",
                description: "Ahora, elige cuánto ahorrar y por cuánto tiempo",
            },
            amountSlider: {
                min: 160,
                max: 700,
                interval: 20,
            },
            flags: {
                invalidCard: false,
                paymentCompleted: false,
                disabledInputs: true,
                olderThanAllowedAge: false,
                validateOtp: false,
                logingIn: false,
                paying: false,
                searching: false,
                showSeeMore: false,
                loadingPlans: false,
                disabledDateOfBirth: true,
                disabledSecondLastName: true,
                disabledLastName: true,
                disabledName: true,
                disabledGender: true,
                sendingQuote: false,
                invalidAge: false,
                invalidDocument: false,
                disableForms: false,
            },
            errors: {
                marketingEmails: false,
                payment: "",
                // payment:
                //     "Tu método de pago fue rechazado. Por favor, confirma que los datos sean válidos o ingresa otra tarjeta.",
            },
            planVisibility: "d-none",
            es: es,
            disabledDates: null,
            marketingEmails: false,
            marketingData: false,
            automaticDebit: true,
            otp: null,
            nextPaymentDate: null,
            requests: [],
            request: null,
            selectedOption: null,
            existingUser: true,
            documentLength: 8,
            countdownInterval: null,
            hours: 23,
            minutes: 59,
            seconds: 59,
            freeMonthModal: false,
            mask: "#XSAa",
            masked: false,
            hashId: "",
            awesome: true,
        };
    },
    validations: function () {
        return {
            userInfo: {
                email: { required, email },
                // firstName: { required },
                // lastName: { required },
                // secondLastName: { required },
                phone: { minLength: minLength(9), required },
                identificationType: { required },
                identificationNumber: {
                    required,
                    numeric,
                    minLength: minLength(this.documentLength),
                    maxLength: maxLength(this.documentLength),
                },
                dateOfBirth: { required },
                inputDob: { required },
                gender: {},
            },
            basicInfo: {
                dateOfBirth: { required },
                gender: { required },
            },
            login: {
                identificationType: { required },
                identificationNumber: { required, numeric },
            },
            quote: {
                email: { required },
            },
            otpCode: {
                code: { required, numeric },
            },
            goal: {
                amount: { required },
                coverage: { required },
                period: { required },
            },
            payment: {
                creditCardNumber: { required },
                creditCardType: {},
                installments: {},
                placeholder: {},
                firstName: {},
                lastName: {},
                secondLastName: {},
                expirationDate: {
                    required,
                    minLength: minLength(5),
                    maxLength: maxLength(5),
                },
                year: {},
                month: {},
                maskedCvv: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(4),
                },
                cvv: {},
                invoice: {},
                email: { required, email },
                phone: { required, numeric },
            },
        };
    },
    created() {
        this.init();
        // window.addEventListener("scroll", this.onWindowScroll);
        // window.addEventListener("mousemove", this.onMouseMove);
    },
    watch: {},
    methods: {
        init() {
            this.loadUser(false);
            this.getInitDate();
            this.initCulqui();
            this.saveInitDatalayerEvent();
        },
        // initCountdown() {
        //   let _context = this;
        //   if (this.countdownInterval) {
        //     clearInterval(this.countdownInterval);
        //   }

        //   _context.hours = 23;
        //   _context.minutes = 59;
        //   _context.seconds = 59;

        //   this.countdownInterval = setInterval(() => {
        //     _context.seconds--;

        //     if (_context.seconds === 0) {
        //       _context.seconds = 59;
        //       _context.minutes--;
        //     }

        //     if (_context.minutes === 0) {
        //       _context.minutes = 59;
        //       _context.hours--;
        //     }
        //   }, 1000);
        // },
        showUserName() {
            let user: any = window.localStorage.getItem("__user__");
            if (user) {
                user = JSON.parse(user);

                return user.firstName;
            }

            return "";
        },
        saveInitDatalayerEvent() {
            this.saveDataLayerEvent({
                event: "virtualPageView",
                pageTitle: "Rumbo | Paso 2",
                pageUrl: "/seguro-de-vida/rumbo/paso/2/",
            });
        },
        initCulqui() {
            Culqi.publicKey = environment.culquiToken;
            Culqi.init();
        },
        getInitDate() {
            let date = moment(new Date());
            let initDate = date.subtract(18, "years");

            this.disabledDates = {
                from: initDate.toDate(),
                openDate: initDate.toDate(),
            };
        },
        back() {
            this.$router.push({
                name: "policies",
            });
        },
        generateNextPaymentDate() {
            moment.locale("es");

            let date: any = new Date();
            let incremental = 0;

            if (date.getDate() == 1) {
                date = moment().add(this.goal.period, "months");
            } else {
                date = moment().add(this.goal.period + 1, "months");
            }

            date = date.format("[1] [de] MMMM [de] YYYY");

            this.nextPaymentDate = date;
        },
        async loadUser(force) {
            this.hashId = window.localStorage.getItem("__hashiId__");

            let user = JSON.parse(window.localStorage.getItem("__user__"));

            this.userInfo.firstName = user.firstName;
            this.userInfo.lastName = user.lastName;
            this.userInfo.secondLastName = user.secondLastName;
            this.userInfo.identificationType = user.identificationType;
            this.userInfo.identificationNumber = user.identificationNumber;
            this.userInfo.email = user.email;
            this.userInfo.phone = user.phoneNumber;

            console.log(this.userInfo);

            let date = user.dateOfBirth.split("/");
            this.userInfo.dateOfBirth = new Date(date[2], date[1] - 1, date[0]);
            this.userInfo.inputDob = user.dateOfBirth;

            this.payment.email = user.email;
            this.payment.phone = user.phoneNumber;

            console.log(this.userInfo.dateOfBirth);

            this.loadOptions();
        },
        async sendQuote() {
            let _context = this;
            if (this.v$.quote.$invalid) {
                this.v$.quote.$touch();
                return;
            }

            let model = {
                email: this.quote.email,
                age: this.getAge(this.userInfo.dateOfBirth),
                gender: true, //this.userInfo.gender == "1",
                coverage: this.goal.coverage,
                monthlyPayment: this.goal.amount,
                planId: this.selectedOption.id,
            };

            this.userInfo.email = this.quote.email;
            this.payment.email = this.quote.email;

            this.flags.sendingQuote = true;
            var result = await axios.post(`${this.apiUrl}quote/send-email`, model);

            if (result.data) {
                this.flags.sendingQuote = false;
                this.flags.sendedQuote = true;

                this.saveDataLayerEvent({
                    event: "select_button",
                    "Nombre Sección": "Rumbo",
                    TipoElemento: "Botón",
                    TipoAccion: "Paso 3 - Programa tus ahorros",
                    CTA: "Seleccionar Botón - Enviar cotización",
                    EmailCotiza: this.quote.email,
                });

                this.saveDataLayerEvent({
                    event: "virtualEvent",
                    category: "Rumbo",
                    action: "Paso 3 - Programa tus ahorros",
                    label: "Seleccionar Botón - Enviar cotización",
                });

                setTimeout(() => {
                    _context.$refs["modal-quote"].hide();
                    _context.flags.sendedQuote = false;
                    _context.quote.email = "";
                    this.v$.quote.$reset();
                }, 4000);
            }
        },
        async loadOptions() {
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            this.flags.loadingPlans = true;

            try {
                var result = await axios.post(
                    `${this.apiUrl}plans`,
                    {
                        amount: this.goal.amount,
                        frecuency: this.goal.period,
                        year: this.getAge(this.userInfo.dateOfBirth), //this.goal.age,
                        gender: "M", //this.userInfo.gender == "1" ? "M" : "F",
                        coverageAmount: this.goal.coverage,
                    },
                    {
                        cancelToken: axiosSource.token,
                    }
                );

                if (result.data) {
                    this.clearOldRequest("Success");

                    if (
                        result.data.availableOptions &&
                        result.data.availableOptions.length === 0
                    ) {
                        this.allOptions = [];
                        this.options = [];
                        this.$refs["modal-no-plans"].show();

                        this.flags.loadingPlans = false;
                        return;
                    }

                    if (result.data.availableOptions.length > 0) {
                        this.flags.showSeeMore = true;
                    } else {
                        this.flags.showSeeMore = false;
                    }

                    let options = result.data.availableOptions;
                    // options.sort(function (a, b) {
                    //   if (a.periodicity > b.periodicity) {
                    //     return -1;
                    //   }
                    //   if (a.periodicity < b.periodicity) {
                    //     return 1;
                    //   }
                    //   return 0;
                    // });

                    options = options.map((el, i) => {
                        return {
                            key: i,
                            duration: el.periodicity,
                            total: el.saved,
                            saved: el.won,
                            rentability: el.saved - el.won,
                            ...el,
                        };
                    });

                    this.allOptions = options;
                    this.options = options; //.slice(0, 3);

                    let defaultOption = this.options.find((el) => {
                        return el.periodicity === 6;
                    });

                    if (defaultOption) {
                        this.goal.option = defaultOption.id;
                        this.selectedOption = defaultOption;
                    } else {
                        this.goal.option = options[0].id;
                        this.selectedOption = options[0];
                    }

                    this.flags.loadingPlans = false;
                }
            } catch (error) {
                // alert(error);
            }
        },
        async nextStep() {

            let _context = this;

            let stepIndex = this.getStepIndex();
            let nextStep = null;
            if (stepIndex >= 0 && stepIndex < this.steps.length - 1) {
                nextStep = this.steps[stepIndex + 1];
            }

            let response = null;
            let model = null;



            if (this.currentStep.key === "userInfo") {
                if (this.v$.userInfo.$invalid) {
                    this.v$.userInfo.$touch();
                    return;
                }
                model = this.userInfo;
                this.payment.placeholder = `${this.userInfo.firstName} ${this.userInfo.lastName}`;
                this.payment.email = this.userInfo.email;
                this.payment.phone = this.userInfo.phone;




                // this.userInfo.gender = this.basicInfo.gender;
                // this.userInfo.dateOfBirth = this.basicInfo.dateOfBirth;

                this.loadOptions();

                this.saveDataLayerEvent({
                    event: "virtualEvent",
                    category: "Rumbo",
                    action: "Paso 2 - Ingresa tus datos personales",
                    label: "Seleccionar botón - Continuar",
                });

                this.saveDataLayerEvent({
                    event: "select_button",
                    "Nombre Sección": "Rumbo",
                    TipoElemento: "Botón",
                    TipoAccion: "Paso 2 - Ingresa tus datos personales",
                    CTA: "Seleccionar botón - Continuar",
                });

                this.saveDataLayerEvent({
                    event: "virtualPageView",
                    pageTitle: "Rumbo | Paso 3",
                    pageUrl: "/seguro-de-vida/rumbo/paso/3/",
                });

                this.saveDataLayerEvent({
                    event: "lead",
                    dimension18: this.userInfo.firstName + " " + this.userInfo.lastName,
                    dimension19: this.userInfo.phone,
                    dimension20: this.userInfo.email,
                    dimension2: this.userInfo.inputDob,
                });

              var resultGenerateLead = analyticsService.sendEvento({
                name: "generate_lead",
                params:{
                  NombresApellidos:
                      this.userInfo.firstName + " " + this.userInfo.lastName,
                  Celular: this.userInfo.phone,
                  Email: this.userInfo.email,
                  TipoDocumento: this.userInfo.documentType,
                  FechaNacimiento: this.userInfo.inputDob,
                }

              }, this.userInfo.identificationNumber)

                /*this.saveDataLayerEvent({
                    event: "generate_lead",
                    NombresApellidos:
                        this.userInfo.firstName + " " + this.userInfo.lastName,
                    Celular: this.userInfo.phone,
                    Email: this.userInfo.email,
                    TipoDocumento: this.userInfo.documentType,
                    FechaNacimiento: this.userInfo.inputDob,
                });*/

                this.initCountdown();
            } else if (this.currentStep.key === "goal") {
                this.generateNextPaymentDate();

                this.saveDataLayerEvent({
                    event: "virtualEvent",
                    category: "Rumbo",
                    action: "Paso 3 - Programa tus ahorros",
                    label: "Seleccionar botón - Continuar",
                });

                this.saveDataLayerEvent({
                    event: "select_button",
                    "Nombre Sección": "Rumbo",
                    TipoElemento: "Botón",
                    TipoAccion: "Paso 3 - Programa tus ahorros",
                    CTA: "Seleccionar botón - Continuar",
                });

                // this.saveDataLayerEvent({
                //   event: "addToCart",
                //   ecommerce: {
                //     currencyCode: "PEN",
                //     add: {
                //       products: [
                //         {
                //           name: this.goal.option.name + " " + this.goal.coverageAmount, // Plan + Año + Cobertura
                //           id: this.goal.option.id,
                //           price: this.goal.option.amount, // Monto Mensual
                //           brand: "Rumbo",
                //           category: this.periods[this.goal.period], // Frecuencia
                //         },
                //       ],
                //     },
                //   },
                // });

                this.saveDataLayerEvent({
                    event: "virtualPageView",
                    pageTitle: "Rumbo | Paso 4",
                    pageUrl: "/seguro-de-vida/rumbo/paso/4/",
                });

                this.saveDataLayerEvent({
                    event: "addToCart",
                    dimension9: this.goal.option.amount,
                    dimension8: this.selectedOption.duration,
                    dimension10: this.periods[this.goal.period],
                    dimension7: this.selectedOption.tea,
                    dimension12: "Interseguro",
                    dimension18: this.userInfo.firstName + " " + this.userInfo.lastName,
                    dimension19: this.userInfo.phone,
                    dimension20: this.userInfo.email,
                    dimension2: this.userInfo.inputDob,
                    ecommerce: {
                        currencyCode: "PEN",
                        add: {
                            products: [
                                {
                                    id: this.selectedOption.id,
                                    name: this.selectedOption.name,
                                    price: this.goal.amount,
                                    brand: "Interseguro",
                                    category: "Rumbo",
                                    variant: "Póliza",
                                    quantity: 1,
                                },
                            ],
                        },
                    },
                });

                this.saveDataLayerEvent({
                    event: "add_to_cart",
                    MontoPoliza: this.goal.option.amount,
                    Periodo: this.selectedOption.duration,
                    FrecuenciaPago: this.periods[this.goal.period],
                    TasaInteres: this.selectedOption.tea,
                    CanalVenta: "Interseguro",
                    NombresApellidos:
                        this.userInfo.firstName + " " + this.userInfo.lastName,
                    Celular: this.userInfo.phone,
                    Email: this.userInfo.email,
                    FechaNacimiento: this.userInfo.inputDob,
                    TipoDocumento: this.userInfo.documentType,
                    ecommerce: {
                        items: [
                            {
                                item_id: this.selectedOption.id,
                                item_name: this.selectedOption.name,
                                price: this.goal.amount,
                                item_brand: "Interseguro",
                                item_category: "Rumbo",
                                item_variant: "Póliza",
                                quantity: 1,
                            },
                        ],
                    },
                });
            } else if (this.currentStep.key === "payment") {
                if (this.invalidExpirationDate) {
                    return;
                }

                if (!this.payment.validCard) {
                    this.flags.invalidCard = true;
                    return;
                }

                if (this.v$.payment.$invalid) {
                    this.v$.payment.$touch();
                    return;
                }
                response = {
                    data: {},
                };
            }

            window.location.href = "#" + nextStep.key;
            this.currentStep = nextStep;
            this.updateStepper();

            if (response) {
                if (response.data !== undefined) {
                }
            }
        },
        getStepIndex() {
            for (let i = 0; i < this.steps.length; i++) {
                if (this.steps[i].key === this.currentStep.key) return i;
            }

            return -1;
        },
        updateStepper() {
            let stepIndex = this.getStepIndex();
            this.steps.forEach(function (el, i) {
                if (i < stepIndex) {
                    el.completed = true;
                    el.active = false;
                } else if (i === stepIndex) {
                    el.completed = false;
                    el.active = true;
                } else if (i > stepIndex) {
                    el.completed = false;
                    el.active = false;
                }
            });
        },
        validateCreditCard() {
            let _context = this;
            let card = valid.number(this.payment.creditCardNumber);
            let cards = {
                visa: "VISA",
                "american-express": "AMEX",
                "diners-club": "DINERS",
                mastercard: "MASTERCARD",
            };
            this.payment.validCard = card.isValid;

            if (this.payment.validCard) this.flags.invalidCard = false;

            if (card.card) {
                this.payment.creditCardType = cards[card.card.type];
            } else {
                this.payment.creditCardType = "";
            }
        },
        validateExpirationDate(event) {
            if (event.keyCode === 8) return;

            let expDate = this.payment.expirationDate;

            if (expDate.length === 2) {
                this.payment.expirationDate = expDate + "/";
            }
        },
        setExpirationDate() {
            if (this.payment.expirationDate.length !== 5) {
                return;
            }

            let currYear = new Date().getFullYear();
            let currMonth = new Date().getMonth() + 1;

            let expDate = this.payment.expirationDate.split("/");
            let month: any = parseInt(expDate[0]);
            let year = parseInt(expDate[1]) + 2000;

            if (month == 0 || month > 12) {
                this.flags.invalidExpirationDate = true;
                return;
            }

            if (new Date(year, month) < new Date(currYear, currMonth)) {
                this.flags.invalidExpirationDate = true;
                return;
            } else {
                this.flags.invalidExpirationDate = false;
            }

            if (month < 10) month = "0" + month;
            else month = month.toString();

            this.payment.month = month;
            this.payment.year = year;
        },
        validateInput(event, regex) {
            let key = event.key;
            let allowedKeys = [8, 9, 13];

            if (!regex.test(key) && allowedKeys.indexOf(event.keyCode) < 0)
                event.preventDefault();
        },
        maskCvv() {
            let _context = this;

            this.payment.cvv = this.payment.maskedCvv;

            setTimeout(function () {
                _context.payment.maskedCvv = _context.payment.maskedCvv.replace(
                    /./g,
                    "*"
                );
            }, 3000);
        },
        setOption(option) {
            this.goal.option = option.id;
            this.nextStep();
        },
        getAge(dob) {
            var today = new Date();
            var birthDate = new Date(dob);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },
        async placeOrder() {
            if (!this.payment.validCard) {
                this.$refs["modal-card-error"].show();
                return;
            }

            window.localStorage.removeItem("__culquiToken__");
            let _context = this;

            this.payment.placeholder = `${this.userInfo.firstName} ${this.userInfo.lastName}`;
            this.payment.phone = this.userInfo.phone;

            if (this.v$.payment.$invalid || this.flags.invalidExpirationDate) {
                this.v$.payment.$touch();
                return;
            }

            this.userInfo.email = this.payment.email;
            this.userInfo.phone = this.payment.phone;
            this.userInfo.firstName = this.payment.firstName;
            this.userInfo.lastName = this.payment.lastName;
            this.userInfo.secondLastName = this.payment.secondLastName;

            // this.$refs["modal-loading"].show();
            this.flags.paying = true;

            Culqi.createToken();

            var checkToken = setInterval(async () => {
                let token = JSON.parse(window.localStorage.getItem("__culquiToken__"));
                console.log(token);
                if (token) {
                    clearInterval(checkToken);

                    if (token && token.id) {
                        let model = {
                            customer: {
                                identificationType: _context.userInfo.identificationType,
                                identificationNumber: _context.userInfo.identificationNumber,
                                firstName: _context.userInfo.firstName,
                                lastName: _context.userInfo.lastName,
                                secondLastName: _context.userInfo.secondLastName,
                                dateOfBirth: moment(_context.userInfo.dateOfBirth).format(
                                    "D/MM/YYYY"
                                ),
                                gender: true, //_context.userInfo.gender == 1,
                                email: _context.userInfo.email,
                                phone: _context.payment.phone,
                                age: this.getAge(_context.userInfo.dateOfBirth), //this.goal.age,
                                marketingData: this.marketingData,
                            },
                            plan: {
                                planId: _context.selectedOption.id,
                                planName: _context.selectedOption.name,
                                periodicity: _context.selectedOption.periodicity,
                                amount: _context.selectedOption.amount,
                                coverageAmount: _context.goal.coverage,
                            },
                            payment: {
                                placeholder: `${_context.userInfo.firstName} ${_context.userInfo.lastName}`,
                                creditCardTokenId: token.id,
                                cardNumber: token.card_number,
                                frecuency: this.goal.period,
                                debitAutomatic: _context.automaticDebit,
                                amount: _context.goal.amount,
                                currency: "PEN",
                                billingEmail: _context.payment.email,
                            },
                        };

                        try {
                            var result = await axios.post(
                                `${_context.apiUrl}policies`,
                                model
                            );

                            if (result.data) {
                                _context.steps[2].completed = true;
                                _context.flags.paymentCompleted = true;

                                this.saveDataLayerEvent({
                                    event: "select_button",
                                    "Nombre Sección": "Rumbo",
                                    TipoElemento: "Botón",
                                    TipoAccion: "Paso 4 - Finaliza tu compra",
                                    CTA: "Seleccionar botón - Continuar",
                                    Estado: "Exitoso",
                                });

                                this.saveDataLayerEvent({
                                    event: "virtualEvent",
                                    category: "Rumbo",
                                    action: "Paso 4 - Finaliza tu compra",
                                    label: "Seleccionar botón - Continuar",
                                });

                                this.saveDataLayerEvent({
                                    event: "orderPurchase",
                                    dimension9: this.selectedOption.amount,
                                    dimension8: this.selectedOption.duration,
                                    dimension10: this.periods[this.goal.period],
                                    dimension7: this.selectedOption.tea,
                                    dimension12: "Interseguro",
                                    dimension18:
                                        this.userInfo.firstName + " " + this.userInfo.lastName,
                                    dimension19: this.userInfo.phone,
                                    dimension20: this.userInfo.email,
                                    dimension2: this.userInfo.inputDob,
                                    ecommerce: {
                                        currencyCode: "PEN",
                                        purchase: {
                                            actionField: {
                                                id: result.data.id,
                                                revenue: this.goal.amount,
                                            },
                                            products: [
                                                {
                                                    id: this.selectedOption.id,
                                                    name: this.selectedOption.name,
                                                    price: this.goal.amount,
                                                    brand: "Interseguro",
                                                    category: "Rumbo",
                                                    variant: "Póliza",
                                                    quantity: 1,
                                                },
                                            ],
                                        },
                                    },
                                });

                                this.saveDataLayerEvent({
                                    event: "purchase",
                                    MontoPoliza: this.selectedOption.amount,
                                    Periodo: this.selectedOption.duration,
                                    FrecuenciaPago: this.periods[this.goal.period],
                                    TasaInteres: this.selectedOption.tea,
                                    CanalVenta: "Interseguro",
                                    NombresApellidos:
                                        this.userInfo.firstName + " " + this.userInfo.lastName,
                                    Celular: this.userInfo.phone,
                                    Email: this.userInfo.email,
                                    FechaNacimiento: this.userInfo.inputDob,
                                    TipoDocumento: this.userInfo.documentType,
                                    ecommerce: {
                                        transaction_id: result.data.id,
                                        value: this.goal.amount,
                                        currency: "PEN",
                                        items: [
                                            {
                                                item_id: this.selectedOption.id,
                                                item_name: this.selectedOption.name,
                                                price: this.goal.amount,
                                                item_brand: "Interseguro",
                                                item_category: "Rumbo",
                                                item_variant: "Póliza",
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                });

                                this.saveDataLayerEvent({
                                    event: "virtualPageView",
                                    pageTitle: "Rumbo | Paso 5",
                                    pageUrl: "/seguro-de-vida/rumbo/paso/5/",
                                });

                                this.$refs["modal-success"].show();
                            }
                        } catch (error) {
                            this.$refs["modal-error"].show();

                            this.saveDataLayerEvent({
                                event: "select_button",
                                "Nombre Sección": "Rumbo",
                                TipoElemento: "Botón",
                                TipoAccion: "Paso 4 - Finaliza tu compra",
                                CTA: "Seleccionar botón - Continuar",
                                Estado: "Error",
                            });

                            this.saveDataLayerEvent({
                                event: "virtualEvent",
                                category: "Rumbo",
                                action: "Paso 4 - Finaliza tu compra",
                                label: "Seleccionar botón - Continuar",
                            });
                        }

                        // this.$refs["modal-loading"].hide();
                        this.flags.paying = false;
                    } else {
                        if (token && token.user_message) {
                            this.errors.payment = token.user_message;
                            this.$refs["modal-error"].show();
                            this.flags.paying = false;
                        }
                        setTimeout(() => {
                            // _context.$refs["modal-loading"].hide();
                            _context.$refs["modal-error"].show();

                            this.saveDataLayerEvent({
                                event: "select_button",
                                "Nombre Sección": "Rumbo",
                                TipoElemento: "Botón",
                                TipoAccion: "Paso 4 - Finaliza tu compra",
                                CTA: "Seleccionar botón - Continuar",
                                Estado: "Error",
                            });

                            this.saveDataLayerEvent({
                                event: "virtualEvent",
                                category: "Rumbo",
                                action: "Paso 4 - Finaliza tu compra",
                                label: "Seleccionar botón - Continuar",
                            });
                        }, 500);
                    }
                }
            }, 500);
        },
        editFields() {
            this.flags.disabledInputs = !this.flags.disabledInputs;
        },
        validateAllowedAge() {
            var date = moment();
            var dob = moment(this.userInfo.dateOfBirth);

            var diff = date.diff(dob, "years");

            // if (diff !== this.goal.age) {
            //   this.flags.invalidAge = true;
            // } else {
            //   this.flags.invalidAge = false;
            // }

            if (diff > 50) {
                this.flags.olderThanAllowedAge = true;
            } else {
                this.flags.olderThanAllowedAge = false;
            }
        },
        changeAmount(value) {
            this.goal.amount = value;

            if (this.request) this.cancel();
            this.loadOptions();
        },
        cancel() {
            this.request.cancel();
            this.clearOldRequest("Cancelled");
        },
        clearOldRequest(msg) {
            this.request.msg = msg;
            this.requests.push(this.request);
            this.request = null;
        },
        goHome() {
            // window.location.href = "/";
            this.$router.push("/");
        },
        async sendOtp() {
            if (this.v$.login.$invalid) {
                this.v$.login.$touch();
                return;
            }

            this.saveDataLayerEvent({
                event: "login",
                userid: this.login.identificationNumber,
            });

            this.flags.logingIn = true;

            let model = {
                identificationType: this.login.identificationType,
                identificationNumber: this.login.identificationNumber,
            };

            var result = await axios.post(
                `${this.apiUrl}sign-in/otp/generate`,
                model
            );

            if (result.data) {
                this.flags.validateOtp = true;
                this.flags.logingIn = false;

                this.otp = result.data;
            }
        },
        async validateOtp() {
            if (this.v$.otpCode.$invalid) {
                this.v$.otpCode.$touch();
                return;
            }

            this.flags.logingIn = true;

            let model = {
                identificationType: this.login.identificationType,
                identificationNumber: this.login.identificationNumber,
                code: this.otpCode.code,
                otpId: this.otp.otpId,
            };

            var result = await axios.post(
                `${this.apiUrl}sign-in/otp/validate`,
                model
            );

            if (result.data) {
                window.localStorage.setItem("__auth__", JSON.stringify(result.data));
                window.location.href = `${this.basePath}/funds/all`;
            } else {
                this.flags.logingIn = false;
            }
        },
        togglePlans() {
            if (this.options.length !== this.allOptions.length) {
                this.options = this.allOptions;
            } else {
                this.options = this.allOptions.slice(0, 3);
            }
        },
        navigateToStep(step) {
            if(!step.completed)
                return;
            
            let index = 0;
            this.steps.forEach((el, i) => {
                if(el.key === step.key) {
                    index = i;
                }
            });

            this.currentStep = step;

            this.steps.forEach((el, i) => {
                if(i <= index) {
                    el.completed = true;
                    el.active = true;
                } else {
                    el.completed = false;
                    el.active = false;
                }
            });
        },
        prevStep() {
            if (this.currentStep.key === "userInfo") {
                // window.location.href = "/";
                this.goHome();
            } else {
                let key = "";

                if (this.currentStep.key === "goal") {
                    key = "userInfo";
                    this.steps[1].active = false;
                    this.steps[1].completed = false;
                    this.steps[2].active = false;
                    this.steps[2].completed = false;
                } else if (this.currentStep.key === "payment") {
                    key = "goal";
                    this.steps[2].active = false;
                    this.steps[2].completed = false;
                }

                this.loadForm(key);
            }
        },
        loadForm(key) {
            let stepIndex = null;
            // let step = null;
            let step = this.steps.find((el, i) => {
                return el.key === key;
            });

            // this.steps.forEach((el, i) => {
            //   if(el.key === key) {
            //     step = el;
            //     stepIndex = i;
            //   }

            //   if(stepIndex && i > stepIndex) {
            //     console.log(i, stepIndex, el)
            //     el.completed = false;
            //     el.active = false;
            //   }
            // })

            if (step) {
                // step.completed = false;
                this.currentStep = step;
            }
        },
        formatNumber(number) {
            let numberArray = number.toString().split("");
            let formattedNumberArray = [];

            numberArray.reverse().forEach((el, i) => {
                if (i % 3 === 0 && i !== 0) {
                    formattedNumberArray.push(",");
                }
                formattedNumberArray.push(el);
            });

            formattedNumberArray = formattedNumberArray.reverse();
            number = formattedNumberArray.join("");

            return number;
            // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        },
        changePeriod() {
            if (this.goal.period == "1") {
                this.goal.amount = 240;

                this.amountSlider.min = 100;
                this.amountSlider.max = 700;
                this.amountSlider.interval = 20;
            } else if (this.goal.period == "3") {
                this.goal.amount = 1008;

                this.amountSlider.min = 336;
                this.amountSlider.max = 1960;
                this.amountSlider.interval = 56;
            } else if (this.goal.period == "12") {
                this.goal.amount = 3600;

                this.amountSlider.min = 1200;
                this.amountSlider.max = 7000;
                this.amountSlider.interval = 200;
            }

            this.loadOptions();
        },
        editField(field) {
            this.flags[`disabled${field}`] = !this.flags[`disabled${field}`];
        },
        saveDataLayerEvent(event) {
            if (window["dataLayer"]) {
                event.userID = this.hashId;

                window["dataLayer"].push(event);
            }
        },
        savePaymentEvent() {
            if (
                !this.payment.validCard ||
                this.payment.year === "" ||
                this.payment.month === "" ||
                this.payment.cvv === ""
            )
                return;

            // this.saveDataLayerEvent({
            //   event: "checkout",
            //   ecommerce: {
            //     checkout: {
            //       actionField: { step: 1 },
            //       products: [
            //         {
            //           name: this.goal.option.name + " " + this.goal.coverage,
            //           id: this.goal.option.id,
            //           price: this.goal.option.amount,
            //           brand: "Rumbo",
            //           category: this.periods[this.goal.period],
            //         },
            //       ],
            //     },
            //   },
            // });
        },
        changeOption(plan) {
            this.selectedOption = plan;
        },
        setDocumentLength() {
            var length = 8;
            if (this.userInfo.identificationType !== "dni") {
                length = 9;
            }

            // if(length > this.userInfo.identificationNumber.length) {
            //   this.flags.invalidDocument = true;
            // } else {
            //   this.flags.invalidDocument = false;
            // }

            this.documentLength = length;
        },
        onWindowScroll(event) {
            // console.log();
            // let width = window.innerWidth;
            // let scrollTop = window.scrollY;
            // var element = document.getElementById("goals");
            // var chatButton = document.getElementById("chatButton");
            // if (scrollTop > 500) {
            //   element.classList.add("fixed");
            //   chatButton.classList.remove("d-none");
            // } else {
            //   element.classList.remove("fixed");
            //   chatButton.classList.add("d-none");
            // }
        },
        onMouseMove(event) {
            if (this.currentStep.key !== "goal") return;

            if (this.freeMonthModal) return;

            let width = window.innerWidth;
            if (event.clientY < 100 && width - event.clientX < 100) {
                let _context = this;
                _context.$refs["modal-free-month"].show();

                this.initCountdown();
                this.freeMonthModal = true;
            }
        },
        closeFreeMonthModal() {
            this.$refs["modal-free-month"].hide();
        },
        changePlaceholder(event) {
            let el = event.target;
            el.setAttribute("placeholder", "dd/mm/aaaa");
        },
        revertPlaceholder(event) {
            let el = event.target;
            el.setAttribute("placeholder", "F. nacimiento");
        },
        validateDob(event) {
            let isBackspace = event.keyCode === 8;

            if (!this.userInfo.inputDob || this.userInfo.inputDob === "") {
                this.flags.invalidAge = true;
                return;
            }

            let dateParts = this.userInfo.inputDob.split("/");

            if (dateParts[0] && dateParts[0] !== "") {
                if (
                    !dateParts[0] ||
                    dateParts[0] > 31 ||
                    dateParts[0] == 0 ||
                    dateParts[0].length === 0
                ) {
                    this.flags.invalidAge = true;
                    return;
                }
            } else {
                this.flags.invalidAge = true;
                return;
            }

            if (dateParts[1] && dateParts[1] !== "") {
                if (
                    !dateParts[1] ||
                    dateParts[1] > 12 ||
                    dateParts[1] == 0 ||
                    dateParts[1].length === 0
                ) {
                    this.flags.invalidAge = true;
                    return;
                }
            } else {
                this.flags.invalidAge = true;
                if (dateParts[0].length === 2 && !isBackspace)
                    // this.userInfo.inputDob += "/";
                    return;
            }

            if (dateParts[2] && dateParts[2] > 1900 && dateParts[2].length === 4) {
                var date: any = new Date(
                    dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2]
                );
                if (date === "Invalid Date") {
                    this.flags.invalidAge = true;
                    return;
                }

                if (date > this.disabledDates.from) {
                    this.flags.invalidAge = true;
                    return;
                }

                this.userInfo.dateOfBirth = date;

                this.flags.invalidAge = false;
                this.validateAllowedAge();
            } else {
                if (!dateParts[2] || dateParts[2] === "")
                    if (dateParts[1].length === 2 && !isBackspace)
                        // this.userInfo.inputDob += "/";
                        this.flags.invalidAge = true;
            }
        },
        updateUserInfo(prop) {
            this.userInfo[prop] = this.payment[prop];
        },
        closeModal(modal) {
            this.$refs[modal].hide();
        },
    },
});
</script>

<style src="@vueform/slider/themes/default.css">

</style>

<style lang="scss">
@import "../../../../styles/abstracts/variables";

/*
    MOB
    */

.hidden-mobile {
    @media (max-width: $mobileBreak) {
        display: none !important;
    }
}

.visible-mobile {
    @media (min-width: $desktopBreak) {
        display: none !important;
    }
}

.newplan {
    padding: 30px 0px 0px 90px;
    background-color: #f1f4f9;

    @media (max-width: $mobileBreak) {
        padding: 0px;
    }

    &__head {
        h4 {
            font-family: $firstFont;
            font-size: 25px;
            color: $fourthGray;

            @media (max-width: $mobileBreak) {
                font-size: 15px;
            }
        }

        &__back {
            display: flex;
            align-items: center;

            a {
                cursor: pointer;
            }

            span {
                font-family: $firstFont;
                font-weight: 600;
                font-size: 24px;
                color: $primaryBlue;
                margin: 0px 0px 0px 25px;

                @media (max-width: $mobileBreak) {
                    font-size: 15px;
                }
            }

            @media (max-width: $mobileBreak) {
                img {
                    width: 10px;
                }
            }
        }
    }

    &__body {
        width: 60rem;

        @media (max-width: $mobileBreak) {
            width: 100% !important;
        }

        &__steps {
            &__head {
                display: flex;
                justify-content: center;

                .steps {
                    position: relative;
                    display: flex;
                    list-style: none;
                    margin: 0;
                    padding: 0;

                    @media (max-width: $mobileBreak) {
                        justify-content: center;
                        margin-top: 20px;
                    }

                    &::before {
                        content: "";
                        position: absolute;
                        width: calc(100% - 45px);
                        top: 20px;
                        right: 0;
                        height: 3px;
                        background-color: $secondBlue;
                    }

                    &__step {
                        font-family: $firstFont;
                        font-weight: 500;
                        font-size: 22px;
                        position: relative;
                        color: $primaryGray;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0px 0px 0px 45px;
                        width: 45px;
                        height: 45px;
                        border-radius: 50%;
                        border: 2px solid $secondBlue;
                        background-color: white;

                        @media (max-width: $mobileBreak) {
                            margin: 0px 0px 0px 55px;

                            &:first-child {
                                margin-left: 0;
                            }
                        }

                        p {
                            font-family: $firstFont;
                            font-weight: 500;
                            font-size: 14px;
                            color: $primaryGray;
                            position: absolute;
                            top: 45px;
                        }

                        &.current {
                            color: white;
                            border: 3px solid $primaryBlue;
                            background-color: $primaryBlue;
                            cursor: pointer;

                            p {
                                color: $primaryBlue;
                            }
                        }
                    }
                }
            }

            &__body {
                display: flex;
                justify-content: start;
                padding: 30px;
                margin: 50px 0px 20px 20px;

                @media (max-width: $mobileBreak) {
                    margin: 0;
                    padding: 0px;
                    margin-top: 40px;
                }

                .step-space {
                    display: block;
                    width: 100px;
                }

                .saves-card {
                    width: 490px;
                    padding: 30px 40px 50px 40px;
                    border-radius: 5px;
                    background-color: white;
                    box-shadow: 0 1px 10px 0 rgba($color: #000000, $alpha: 0.2);

                    @media (max-width: $mobileBreak) {
                        width: 100% !important;
                        border-radius: 20px;
                        padding: 20px 0px 10px 0px;
                        box-shadow: 0 1px 10px 0 rgba($color: #000000, $alpha: 0.1);
                    }

                    &__title {
                        font-size: 18px;
                        display: block;
                        text-align: center;
                        color: $primaryBlue;
                        margin-bottom: 58px;
                        font-weight: 500;
                    }

                    &__slider {
                        padding: 0px 30px 0px 30px;
                        position: relative;


                        .slider-target {
                            width: 100%;
                            height: 10px;
                            margin-bottom: 10px;

                            &:hover .slider-connects .slider-connect {
                                background-color: #36abff;
                            }

                            .slider-connects {

                                .slider-connect {
                                    background-color: $primaryBlue;
                                }
                            }

                            .slider-origin {
                                .slider-tooltip {
                                    font-family: $firstFont;
                                    font-weight: 500;
                                    font-size: 18px;
                                    color: $primaryBlue;
                                    border: none;
                                    bottom: 28px;
                                    background-color: transparent;

                                    &::before {
                                        content: none;
                                    }
                                }

                                .slider-handle {
                                    width: 26px;
                                    height: 26px;
                                    box-shadow: none;
                                    background-color: $primaryBlue;
                                    transition: 0.3s;

                                    &:hover {
                                        background-color: #36abff;
                                    }
                                }

                                .slider-touch-area {
                                    &::before {
                                        content: '';
                                        position: absolute;
                                        top: 8px;
                                        left: 8px;
                                        width: 10px;
                                        height: 10px;
                                        border-radius: 50%;
                                        background-color: white;
                                    }
                                }
                            }
                        }

                        .vue-slider-dot {
                            .vue-slider-dot-tooltip-top {
                                top: 0px;
                            }

                            .vue-slider-dot-tooltip-inner.vue-slider-dot-tooltip-inner-top {
                                font-family: $firstFont;
                                font-weight: 500;
                                font-size: 18px;
                                padding: 0;
                                color: $primaryBlue;
                                background-color: transparent !important;

                                &::after {
                                    display: none;
                                }

                                span {
                                    display: block;
                                }
                            }
                        }

                        .vue3-slider {
                            margin-bottom: 10px;

                            .tooltip {
                                font-size: 18px;
                                font-weight: 500;
                            }

                            .track {
                                height: 10px;
                                border-radius: 10px;
                            }

                            .track-filled {
                                height: 10px;
                                border-radius: 10px;
                            }

                            .handle {
                                //top: 0px;
                                width: 17px;
                                height: 17px;
                                border-radius: 100%;
                                //width: 11px;
                                //height: 11px;
                                top: -2px;
                                //background-color: #6a98db;
                                background-color: $primaryBlue !important;

                                &::before {
                                    content: '';
                                    position: absolute;
                                    top: 5px;
                                    left: 5px;
                                    width: 7px;
                                    height: 7px;
                                    border-radius: 50%;
                                    background-color: white;
                                }

                                &.hover {
                                    background-color: #36abff;
                                }
                            }
                        }



                        .vue3-slider {
                            .tooltip {
                                display: block !important;
                                opacity: 1 !important;
                                transform: translate(105.333px);
                                --tooltip-margin: max(calc(var(--height, 6px) + 12px), calc(var(--height, 6px) * var(--handle-scale, 1.5)));
                                //bottom: var(--tooltip-margin) !important;
                                bottom: 18px !important;
                                top: unset;
                            }

                            .handle {
                                transform: scale(1.5);
                            }
                        }

                        .vue3-slider .tooltip {
                            height: 22px;
                            font-size: 18px;
                            font-weight: 500;
                            background-color: transparent !important;
                        }

                        .min,
                        .max {
                            padding: 0px 20px 0px 20px;
                            position: absolute;
                        }

                        .min {
                            left: 12px;
                            font-size: 16px;
                            color: #7b7c9a;
                        }

                        .max {
                            right: 12px;
                            font-size: 16px;
                            color: #7b7c9a;
                        }
                    }

                    &__savings {
                        padding: 0px 20px 0px 20px;

                        &__title {
                            font-size: 18px;
                            display: block;
                            text-align: center;
                            color: $primaryBlue;
                            margin: 64px 0px 20px 0px;
                            font-weight: 500;
                        }

                        &__years {
                            display: flex;
                            flex-direction: row;

                            .form-group {
                                display: flex;
                                width: 100%;

                                input[type="radio"] {
                                    display: none;
                                }

                                input[type="radio"]:checked~label {
                                    color: white;
                                    background-color: $primaryBlue;
                                }

                                label {
                                    font-family: $firstFont;
                                    font-weight: 500;
                                    font-size: 18px;
                                    color: #5e5873;
                                    display: block;
                                    position: relative;
                                    text-align: center;
                                    width: 100%;
                                    padding: 5px 0px 5px 0px;
                                    border: 1px solid $primaryGray;
                                    border-left: none;
                                    cursor: pointer;
                                    transition: 0.3s;
                                }
                            }

                            .form-group:first-child {
                                label {
                                    border-top-left-radius: 20px;
                                    border-bottom-left-radius: 20px;
                                    border: 1px solid #7b7c9a;
                                }
                            }

                            .form-group:last-child {
                                label {
                                    border-top-right-radius: 20px;
                                    border-bottom-right-radius: 20px;
                                }
                            }
                        }

                        &__loader {
                            text-align: center;
                            font-size: 20px;
                            color: $primaryBlue;
                            margin: 50px 0px 0px 0px;

                            span {
                                font-family: $firstFont;
                                font-size: 18px;
                                font-weight: 500;
                                display: block;
                                color: $primaryGray;
                            }
                        }
                    }

                    &__annual {
                        margin: 30px 0px 10px 0px;
                        padding: 20px 10px 10px 10px;
                        background: #e2f7ff 0% 0% no-repeat padding-box;

                        .row:first-child {
                            @media (max-width: $mobileBreak) {
                                margin-bottom: 15px;

                                .col:nth-child(1) {
                                    padding-right: 0;
                                }

                                .col:nth-child(2) {
                                    margin: 0;
                                    padding: 0;
                                }

                                .col:nth-child(3) {
                                    padding-left: 0;
                                }
                            }
                        }

                        .box {
                            position: relative;
                            text-align: center;

                            p {
                                font-weight: 500;
                                color: $primaryBlue;
                                margin: 0;
                            }

                            span {
                                font-weight: 500;
                                font-size: 12px;
                                display: block;
                                color: $primaryGray;
                                line-height: 15px;
                            }
                        }

                        .row {
                            .col:first-child {
                                .box {
                                    p::before {
                                        content: "+";
                                        position: absolute;
                                        right: -10px;
                                        font-size: 20px;
                                        width: 15px;
                                        height: 15px;
                                    }
                                }
                            }

                            .col:nth-child(2) {
                                .box {
                                    p::before {
                                        content: "=";
                                        position: absolute;
                                        right: -7px;
                                        font-size: 20px;
                                        width: 15px;
                                        height: 15px;
                                    }
                                }
                            }
                        }

                        .box-b {
                            .row {
                                display: flex;
                                justify-content: center;
                                align-items: center;

                                .col {
                                    span {
                                        font-weight: 500;
                                        font-size: 16px;
                                        display: block;
                                        padding-top: 20px;
                                        text-align: right;
                                        color: $primaryBlue;
                                    }
                                }

                                .col-4 {
                                    position: relative;

                                    @media (max-width: $mobileBreak) {
                                        margin-right: 10px;
                                    }

                                    p {
                                        font-weight: 700;
                                        font-size: 32px;
                                        color: $primaryBlue;
                                        margin: 0;
                                    }

                                    span {
                                        display: block;
                                        font-size: 12px;
                                        line-height: 0px;
                                    }
                                }
                            }
                        }

                        &__btn {
                            font-family: $firstFont;
                            font-weight: 500;
                            font-size: 18px;
                            width: 70%;
                            height: 50px;
                            color: white;
                            border: none;
                            margin: 25px 0px 30px 0px;
                            border-radius: 5px;
                            background-color: #ea0c90;
                            box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.2);
                        }
                    }
                }

                .summary-card {
                    width: 300px;
                    overflow: hidden;
                    border-radius: 20px;
                    background-color: white;
                    box-shadow: 0 1px 10px 0 rgba($color: #000000, $alpha: 0.2);

                    &__title {
                        display: block;
                        text-align: center;
                        width: 100%;
                        padding: 5px;
                        font-size: 18px;
                        color: white;
                        background-color: $primaryBlue;
                    }

                    &__data {
                        list-style: none;
                        padding: 0;
                        margin: 0px 0px 20px 0px;

                        li {
                            display: flex;
                            width: 100%;
                            font-size: 18px;
                            padding: 0px 0px 0px 0px;
                            justify-content: space-between;

                            &:first-child {
                                margin: 20px 0px 0px 0px;
                            }

                            .row {
                                display: flex;
                                align-items: center;
                                margin: 0;
                                padding: 0;
                                width: 100%;

                                .col-sm {
                                    margin: 0;
                                    padding: 0px 20px 0px 20px;
                                }

                                .col-sm:first-child {
                                    text-align: right;
                                }

                                span {
                                    font-weight: 500;
                                    font-size: 14px;
                                    color: $primaryBlue;
                                    display: block;
                                    text-align: left;
                                }

                                p {
                                    font-weight: 500;
                                    margin: 0;
                                    color: $primaryGray;
                                    text-align: right;
                                }
                            }
                        }
                    }

                    &__interest {
                        // margin: 10px 0px 0px 0px;
                        padding: 15px 0px 15px 0px;
                        background: #e2f7ff 0% 0% no-repeat padding-box;

                        .row {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            margin: 0;
                            padding: 0;
                            width: 100%;

                            .col-sm {
                                display: flex;
                                justify-content: center;
                                text-align: center;
                            }

                            .col-sm:first-child {
                                span {
                                    font-weight: 500;

                                    br {
                                        display: none;
                                    }
                                }
                            }

                            span {
                                font-size: 14px;
                                font-weight: 600;
                                color: $primaryBlue;
                                width: 100%;
                            }

                            p {
                                font-weight: 700;
                                font-size: 30px;
                                color: $primaryBlue;
                                margin: 0;
                            }
                        }
                    }

                    &__btn {
                        font-family: $firstFont;
                        font-weight: 500;
                        font-size: 18px;
                        width: 60%;
                        height: 50px;
                        color: white;
                        border: none;
                        margin-top: 28px;
                        margin-bottom: 15px;
                        border-radius: 5px;
                        background-color: $primaryPink;
                        box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.2);
                    }
                }
            }
        }
    }

    .quote {
        background-color: transparent !important;

        @media (max-width: $mobileBreak) {
            margin-top: 10px;
        }

        &__stepper {
            width: 150px;
            margin-left: auto;
            margin-right: auto;

            &__item {
                &:before {
                    width: calc(100% - 45px);
                }
            }
        }

        &__step {
            //background-color: #fff;
            padding: 15px;
            border-radius: 20px;

            @media (max-width: $mobileBreak) {
                margin: 0;
                padding: 0px;
            }

            @media (min-width: 940px) {
                .card-1-quote-step-2 {
                    width: 438px !important;
                }
            }

            @media (max-width: 479px) {
                .card-1-quote-step-2 {
                    width: 100% !important;
                }
            }
        }

        .summary {
            background-color: white;
            padding: 0;
            border-radius: 20px;
            padding: 30px !important;
            margin: 0 !important;
            box-shadow: 0px 2px 20px rgba(80, 80, 80, 10%) !important;

            @media (min-width: 940px) {
                &.card-2-quote-step-2 {
                    width: 370px !important;
                }
            }

            @media (max-width: 479px) {
                &.card-2-quote-step-2 {
                    width: 100% !important;
                }
            }

            &__section {
                &__label {
                    font-size: 15px;
                    color: $primaryBlue !important;
                    text-align: left;
                    font-weight: 500;

                    @media (max-width: $mobileBreak) {
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        margin-bottom: 30px !important;
                    }

                    button {
                        display: flex;
                        align-items: center;

                        @media (max-width: $mobileBreak) {
                            p {
                                color: $primaryBlue;
                                margin: 7px 0px 0px 15px;
                            }

                            &::before {
                                content: none;
                            }
                        }
                    }
                }

                &__infouser {
                    margin-top: 25px;
                    margin-bottom: 8px;
                    color: $primaryGray;

                    span {
                        font-size: 15px;
                        font-weight: 500;
                        display: block;
                        text-align: left;
                    }
                }

                &__detail {
                    color: $primaryGray;

                    .row {
                        margin-top: 5px !important;

                        span {
                            font-size: 14px;

                            a {
                                color: $primaryGray;
                                text-decoration: none !important;
                            }
                        }

                        div:last-child {
                            font-size: 14px;
                        }

                        .col-5 {
                            word-wrap: break-word;
                        }
                    }
                }

                &__btn {
                    font-family: $firstFont;
                    font-weight: 500;
                    font-size: 18px;
                    width: 70%;
                    height: 45px;
                    color: white;
                    border: none;
                    margin: 25px 0px 0px 0px;
                    border-radius: 5px;
                    background-color: #ea0c90;
                    box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.2);
                }
            }

            &__info {
                margin-top: 15px;

                .summary {
                    &__section {
                        &__detail {
                            span {
                                display: block;
                                font-size: 14px !important;
                                text-align: center;
                                width: 100%;

                                a {
                                    color: $fiveBlue !important;
                                    text-decoration: underline;

                                    &:hover {
                                        color: $primaryBlue !important;
                                    }
                                }
                            }

                            a {
                                color: $primaryBlue;
                            }
                        }
                    }
                }

                small {
                    font-size: 12px;

                    span {
                        display: flex;
                    }
                }
            }
        }

        /*VISIBLE MOBILE*/

        .payment-step {
            margin-bottom: 30px;
            border-radius: 15px;
            background-color: white;

            @media (max-width: $mobileBreak) {
                .row {
                    margin: 0 !important;
                    padding: 0 !important;
                }

                .col-md-6 {
                    padding: 0;
                }

                .summary {
                    padding: 30px !important;
                    background-color: white !important;
                    box-shadow: none !important;
                }

                .visible-mobile {
                    .summary {
                        &__section {
                            &__infouser {
                                display: flex;
                                justify-content: start;
                                margin-bottom: 20px !important;
                            }

                            &__detail {
                                .row {
                                    display: flex;
                                    align-items: baseline;
                                    margin-bottom: 4px !important;
                                }

                                .col-7 {
                                    text-align: left;
                                    padding: 0;

                                    span {
                                        display: block;
                                        text-decoration: none;
                                        color: $primaryGray;
                                        font-size: 15px !important;
                                    }
                                }

                                .col-5 {
                                    text-align: left;
                                    padding: 0;

                                    span {
                                        display: block;
                                        text-decoration: none;
                                        word-wrap: break-word !important;
                                        width: 100%;
                                        color: $primaryGray;
                                        font-size: 15px !important;
                                    }

                                    b {
                                        display: block;
                                        font-size: 15px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        /**/

        .paycard {
            border: none;

            .paycard__box {
                color: $primaryGray;
                border-radius: 20px;
                background-color: #fff;
                box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.1);

                .hidden-mobile {
                    span {
                        font-size: 15px;
                        display: block;
                        margin: 20px 0px 15px 0px;
                    }

                    .card-brands {
                        margin-bottom: 10px;
                    }
                }

                .visible-mobile {
                    padding: 10px;

                    span {
                        font-size: 15px;
                    }

                    .payments-cards {
                        .card-brands {
                            img {
                                margin: 10px 0px 10px 0px;
                                width: 250px !important;
                            }
                        }
                    }
                }

                &__btn {
                    font-family: $firstFont;
                    font-weight: 500;
                    font-size: 18px;
                    width: 90%;
                    height: 55px;
                    color: white;
                    border: none;
                    margin: 0px 0px 30px 0px;
                    border-radius: 5px;
                    background-color: #ea0c90;
                    box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.2);
                }

                .cardpays {
                    @media (max-width: $mobileBreak) {
                        padding: 0px 25px 0px 25px !important;
                    }

                    .form-group {

                        .custom-checkbox {
                            .custom-control-input:checked~.custom-control-label::after {
                                content: '';
                                color: white;
                                left: 5px;
                                font-weight: lighter;
                                display: flex;
                                justify-content: center;
                                background-size: 58%;
                                background-repeat: no-repeat;
                                background-position: center;
                                background-image: url('../../../../assets/check-white.svg');

                            }

                            .custom-control-label {
                                span {
                                    color: $primaryBlue !important;
                                    font-weight: 500;
                                }
                            }
                        }

                        .form-control {
                            &::placeholder {
                                color: $secondGray;
                                transition: 0.3s;
                            }

                            &:focus {
                                box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.1);
                            }

                            &:focus::placeholder {
                                padding-left: 5px;
                            }
                        }
                    }
                }
            }
        }
    }
}

.summary::after,
.summary::before {
    content: none !important;
}
</style>